import {Component} from 'react'
import {Dispath} from 'react-redux'
import {module_list, type_list} from '~/helper/constant/category'



type Props = {
    dispatch: Dispath<any>
}
type State = {}

export class AbstractConstantCustomFieldAddComponent extends Component <Props, State>{
    constructor(props:Props){
        super(props)
        this.state ={
            loading: false,
            loading_text:'Loading',
            type_list: type_list,
            module_list: module_list
        }
    }
    compnentDidMount(){}


}

export function mapStateToProps(state:Object){
    return {
        token: state.token,
    }
}